import React, { useState } from "react";
import RangeDatePicker from "shared/components/rangeDatePicker";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import { routeConstant } from "shared/routes/routesConstant";
import styles from "./style.module.scss";
import { Box, Tab, Tabs } from "@mui/material";
import classNames from "classnames";
import { Images } from "assets";
import useWindowSize from "shared/customHooks/windowSize";

function PhNewLeadershipBoard() {
  const screenWidth = useWindowSize();
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [activeTab, setActiveTab] = useState<any>(0);

  useBreadcrumbs(
    {
      title: "Leadership Board",
      path: routeConstant?.leadershipBoard?.path,
    },
    true
  );

  const tabs = [
    {
      value: 0,
      label: "Website (Global)",
    },
    {
      value: 1,
      label: "Schools",
    },
  ];

  const handleChange = (event: any, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.headingContainer}>
        <div className={styles.heading}>Leadership Board History</div>

        <div className={styles.dateContainer}>
          <RangeDatePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            doubleLabel={screenWidth > 650 ? true : false}
          />
        </div>
      </div>

      <div className={styles.boardContainer}>
        <Box className={styles.boxContainer}>
          <Tabs
            value={activeTab}
            onChange={handleChange}
            className={styles.tab}
            TabIndicatorProps={{
              style: {
                backgroundColor: "black",
              },
            }}
            sx={{ background: "white", padding: "0px 14px" }}
          >
            {tabs?.map((item: any, index: any) => {
              return (
                <Tab
                  label={
                    <div className={classNames(styles.tabs)}>
                      <label
                        className={classNames(
                          styles.tabLabel,
                          activeTab === item?.value && styles.active
                        )}
                      >
                        {item?.label}
                      </label>
                    </div>
                  }
                  sx={{ padding: "0px" }}
                />
              );
            })}
          </Tabs>
          <div className={styles.separator} />
        </Box>

        <div className={styles.cardContainer}>
          <React.Fragment>
            {Array.from({ length: 5 }).map((_, index) => (
              <div className={styles.singleBadgeContainer}>
                <div
                  className={classNames(styles.leadherShipSubContainer)}
                  style={
                    index === 0
                      ? { backgroundColor: "#f9a11b" }
                      : index === 1
                      ? { backgroundColor: "#1897A6" }
                      : index === 2
                      ? { backgroundColor: "#9A469B" }
                      : index === 3
                      ? { backgroundColor: "#C2D52E" }
                      : index === 4
                      ? { backgroundColor: "#58C0BF" }
                      : {}
                  }
                >
                  <div className={styles.userImageContainer}>
                    <img
                      src={Images.UserPlaceholderImage}
                      alt="img-container"
                      className={styles.userImg}
                    />
                  </div>

                  <div className={styles.infoContainer}>
                    <div className={styles.nameContainer}>
                      <label className={styles.kidLabel}>Kid Name</label>
                      <label className={styles.kidEmail}>
                        reader@yopmail.com
                      </label>
                    </div>
                    <div
                      style={{ display: "flex" }}
                      className={styles.mainInfoContainer}
                    >
                      <div className={styles.singleInfoContainer}>
                        <label className={styles.titleLabel}>Age:</label>
                        <label className={styles.countLabel}>10 Years</label>
                      </div>
                      <div className={styles.singleInfoContainer}>
                        <label className={styles.titleLabel}>Badges:</label>
                        <label className={styles.countLabel}>2 Badges</label>
                      </div>
                      <div className={styles.singleInfoContainer}>
                        <label className={styles.titleLabel}>
                          Books Completed:
                        </label>
                        <label className={styles.countLabel}>30 Books</label>
                      </div>
                    </div>
                  </div>
                  <div className={styles.badgeContainer}>
                    <img
                      src={
                        index === 0
                          ? Images.FirstBadge
                          : index === 1
                          ? Images.SecondBadge
                          : index === 2
                          ? Images.ThirdBadge
                          : index === 3
                          ? Images.FourthBadge
                          : Images.FifthBadge
                      }
                      alt="profile-pic"
                      height={103}
                      width={103}
                    />
                  </div>
                </div>
              </div>
            ))}
          </React.Fragment>
        </div>
      </div>
    </div>
  );
}

export default PhNewLeadershipBoard;
